import { Component, computed, inject } from '@angular/core';
import dayjs from 'dayjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { WeightService } from '../../../../services/weight.service';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { CardHeaderComponent } from '../../../atoms/card-header/card-header.component';
import { CardComponent } from '../../../atoms/card/card/card.component';
import { NoEntriesPlaceholderComponent } from '../../../molecules/no-entries-placeholder/no-entries-placeholder.component';
import { PaginatorComponent } from '../../../molecules/paginator/paginator.component';
import { PaginatorIntervalTypeEnum } from '../../../molecules/paginator/paginator.enum';
import { WeightItemComponent } from '../../../molecules/weight-item/weight-item.component';
import { MainLayoutComponent } from '../../../organisms/main-layout/main-layout.component';
import { ModelCreateUpdateWeigthComponent } from '../../../organisms/modal/model-create-update-weigth/model-create-update-weigth.component';
import { WeightList } from './weight.types';

@Component({
  selector: 'app-weight',
  templateUrl: './weight.component.html',
  imports: [
    MainLayoutComponent,
    CardComponent,
    CardHeaderComponent,
    ButtonComponent,
    WeightItemComponent,
    NoEntriesPlaceholderComponent,
    PaginatorComponent,
  ],
})
export class WeightComponent {
  protected readonly paginatorIntervalTypeEnum = PaginatorIntervalTypeEnum;
  protected readonly RequestStateEnum = RequestStateEnum;

  private readonly weightService = inject(WeightService);
  private readonly modalService = inject(ModalService);

  public requestState = this.weightService.getRequestState();
  public weightEntries = this.weightService.getWeightItems;

  public sortedWeightEntries = computed<WeightList>(() =>
    this.sortWeightEntries(this.weightEntries() ?? [])
  );

  public onPaginatorChange(index: number, year: number): void {
    const start = dayjs().year(year).month(index).startOf('month');
    const end = dayjs().year(year).month(index).endOf('month');

    this.weightService.fetchWeightItems(start, end);
  }

  public sortWeightEntries(items: WeightList): WeightList {
    return items.sort((a, b) => {
      const aDate = dayjs(a.date, 'YYYY-MM-DD');
      const bDate = dayjs(b.date, 'YYYY-MM-DD');

      return aDate.isBefore(bDate) ? 1 : -1;
    });
  }

  public openCreateUpdateWeightModal(id?: string): void {
    if (id) {
      this.modalService.openOverlayWithConfig(ModelCreateUpdateWeigthComponent, { id });
    } else {
      this.modalService.openOverlayWithConfig(ModelCreateUpdateWeigthComponent);
    }
  }
}
